const modal = document.getElementById('quick-add-modal');

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('.quick-add-btn');

  if (!btn) return;

  const handle = btn.dataset.productHandle;

  modal.classList.add('active');

  const response = await fetch(
    `/products/${handle}?view=quick-add`
  );

  const html = await response.text();
  const modal_body = document.getElementById(
    'quick-add-body'
  );

  modal_body.innerHTML = html;

  initQuickGallery(modal);

  updateQuickForm();
});


document.addEventListener('click', (e) => {

  if (
    e.target.classList.contains(
      'quick-add-close'
    )
  ) {
    modal.classList.remove('active');
  }

});


document.addEventListener('submit', async (e) => {

  e.preventDefault();
   console.log(e.target.id);
  console.log(e.target.id == 'quick-add-form');
  

 if (!e.target.matches('.quick-product__form')) return;


const form = e.target;

const formData = new FormData(form);

try {

const response = await fetch('/cart/add.js', {

method: 'POST',

body: formData,

headers: {

Accept: 'application/json'

}

});

const item = await response.json();

console.log('Added:', item);

modal.classList.remove('active');

// Open Impulse cart drawer

setTimeout(() => {

document

.querySelector('.js-drawer-open-cart')

?.click();

}, 200);

} catch (error) {

console.error('Add to cart failed:', error);


}




});


document.addEventListener('click', function(e){

    if(!e.target.classList.contains('quick-thumb')) return;

    document.getElementById('quick-main-image').src =
        e.target.dataset.full;

    document.querySelectorAll('.quick-thumb').forEach(function(img){
        img.classList.remove('active');
    });

    e.target.classList.add('active');

});

// slider
function initQuickGallery(container) {

    const gallery = container.querySelector('.quick-gallery');
    if (!gallery) return;
    if (gallery.swiper) {
        gallery.swiper.destroy(true, true);
    }

    new Swiper(gallery, {
        // mobile-first defaults (< 769px)
        slidesPerView: 1.6,
        spaceBetween: 6,
        centeredSlides: true,
        loop: false,
        pagination: {
            el: gallery.querySelector('.swiper-pagination'),
            clickable: true
        },
        breakpoints: {
            // 769px and up (desktop)
            769: {
                slidesPerView: 1.3,
                spaceBetween: 12
            }
        }
    });
}

document.addEventListener('click', function (e) {

    const btn = e.target.closest('.quick-qty-btn');
    if (!btn) return;

    const selector = btn.closest('.quick-product__qty-selector');
    if (!selector) return;

    const input = selector.querySelector('input[name="quantity"]');
    if (!input) return;

    let value = Number(input.value) || 1;

    value += btn.dataset.action === 'plus' ? 1 : -1;

    if (value < 1) value = 1;

    input.value = value;

});

function updateQuickForm() {

    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll('.quick-product__sizes input').forEach(input => {
        input.disabled = isMobile;
    });

    document.querySelectorAll('.quick-product__select').forEach(select => {
        select.disabled = !isMobile;
    });

    document.querySelectorAll('.quick-desktop-only input[name="quantity"]').forEach(input => {
        input.disabled = isMobile;
    });

    document.querySelectorAll('.quick-mobile-options input[name="quantity"]').forEach(input => {
        input.disabled = !isMobile;
    });

}

window.addEventListener('resize', updateQuickForm);